import React from "react"
import { EvidenceViewer } from '../mdp'


type OneConditionEvidenceOwnProps = {
    match: {
        params: {
            mdpSourceId: string
            mdpSourceType: string
        }
    }
}

function OneCondition(
    props: OneConditionEvidenceOwnProps
): JSX.Element {
  const {
    match
  } = props

  const { mdpSourceId } = match.params
  const { mdpSourceType } = match.params

  return (
      <>
        { <EvidenceViewer isClosable={false} showIcon nlpSourceType={mdpSourceType} nlpSourceId={mdpSourceId} /> }
      </>
  )
}


export default OneCondition;